export const GET_CATEGORY = "/api/v1/category";
export const GET_CATEGORY_SEARCH = "/api/v1/category/search";
export const GET_CATEGORY_SELECT = "/api/v1/category/selectcategory";
export const UPDATE_PRODUCT = "/api/v1/products/productavailability";
export const UPDATE_PRODUCT_MAIN = "/api/v1/products/isAvailibility"
export const POST_PRODUCTS = "/api/v1/products/create";
export const POST_DRAFT = "/api/v1/product-draft";
export const UPDATE_PRODUCTS = "/api/v1/products/update/";
export const UPDATE_DRAFTS = "/api/v1/product-draft/";
export const SIGNUP = "/api/v1/auth/signup";
export const REFRESH = "/api/v1/auth/refresh";
export const CREATE_BUSINESS = "/api/v1/business/create";
export const VALIDATE_STORE_NAME = "/api/v1/auth/validateStoreName";
export const ME = "/api/v1/auth/me";
export const GET_PRODUCTS = "/api/v1/products/sellerproducts";
export const GET_PRODUCTS_CAMPAIGN = "/api/v1/marketing-campaign/product/seller";
export const GET_DRAFT_PRODUCTS = "/api/v1/product-draft/seller";
export const LOGIN = "/api/v1/auth/login";
export const FORGET_PASSWORD = "/api/v1/auth/forgotpassword?";
export const CHANGE_PASSWORD = "/api/v1/auth/changepassword";
export const UPDATE_BUSINESS = "/api/v1/business/update";
export const UPDATE_ORDER_STATUS = "/api/v1/order/updateorderstatus";
export const GET_BRAND_BY_KEYWORD = "/api/v1/sellersubbrands";
export const GET_SELLER_PERFORMANCE = "/api/v1/product-performance";
export const GET_LOAD_SHEET = "/api/v1/business/loadSheets";
export const GET_CATEGORY_PRODUCT_PERFORMANCE = "/api/v1/product-performance/categories";
export const GET_KEY_METRICS = "/api/v1/key-metrics";
export const GET_INCOME_OVERVIEW = "/api/v1/order-statements";
export const GET_INCOME_Detail = "/api/v1/order-statements/income/detail";
export const GET_CHAT_ORDERS = "/api/v1/chat/orders";
export const GET_CHAT_STATUS = "/api/v1/chat/chatStatus";
export const UPLOAD_VOUCHER = "/api/v1/vouchers/upload/products";
export const UPLOAD_PRODUCT = "/api/v1/marketing-campaign/upload/subProducts";
export const GET_CHAT_VOUCHER = "/api/v1/chat/vouchers";
export const GET_MARKETING_CAMPAIGN_INVITITION = "/api/v1/marketing-campaign/invitition";
export const PUT_REGISTER = "/api/v1/marketing-campaign/register";
export const PUT_CAMPAIGN_PRICE = "/api/v1/marketing-campaign/productprice";
export const PUT_CAMPAIGN_WITHDRAWN = "/api/v1/marketing-campaign/withdrawn";
export const PUT_CAMPAIGN_ADD_PRODUCT = "/api/v1/marketing-campaign/product";
export const GET_CHAT_PRODUCTS = "/api/v1/chat/products";
export const GET_CHAT_CREATE = "/api/v1/chat";
export const UPDATE_FOLDER_NAME = "/api/v1/folder/update";
export const CREATE_BRAND_DETAIL = "/api/v1/brand/create";
export const GET_BRAND_SEARCH = "/api/v1/brand/allbrands";
export const GET_BUSINESS_SELLER_ID = "/api/v1/business/businessbysellerid";
export const GET_BANKS = "/api/v1/business/getbank";
export const GET_RETURN_ORDER_DETAIL = "/api/v1/order/return/detail";
export const GET_ORDERS = "/api/v1/order/sellerorders";
export const GET_RETURN_ACITIVITIES = "/api/v1/order/returnActivities";
export const GET_ACITIVITIES = "/api/v1/order/activities";
export const GET_ORDERS_DETAIL = "/api/v1/order/detail";
export const GET_PRODUCT_DRAFT_DETAIL = "/api/v1/product-draft/";
export const GET_STATE = "/api/v1/address/states";
export const GET_CITY = "/api/v1/address/cities";
export const GET_ZONES = "/api/v1/address/zones";
export const GET_NEIGHBORHOOD = "/api/v1/address/neighborhood";
export const GET_PRODUCT_DETAIL = "/api/v1/products/detail";
export const GET_PRODUCT_BY_ID = "/api/v1/products/edit/";
export const DELETE_PRODUCT_BY_ID = "/api/v1/products/delete/"
export const GET_CHECK_USERNAME = "/api/v1/auth/check/"
// export const GET_PRIVACY_POLICY = "/api/v1/auth/policies?type=sellerPrivacyPolicy&isBuyPassPolicy=true"; 

export const GET_PRIVACY_POLICY = (type: string, isBuyPassPolicy: boolean) =>
    `/api/v1/auth/policies?type=${type}&isBuyPassPolicy=${isBuyPassPolicy}`;

export const GET_TERM_AND_CANDITIONS = (type: string, isBuyPassPolicy: boolean) =>
    `/api/v1/auth/policies?type=${type}&isBuyPassPolicy=${isBuyPassPolicy}`;
  
export const GET_OTP_SEND = "/api/v1/otp-code/send"
export const GET_OTP_VERIFY = "/api/v1/otp-code/verify"
export const GET_OTP_RESEND = "/api/v1/otp-code/resend"
export const CREATE_MEDIA = "/api/v1/media-center/create"
export const GET_MEDIA = "/api/v1/media-center/images"
export const GET_MEDIA_VIDEO = "/api/v1/media-center/videos"
export const DELETE_MEDIA_BY_IDS = "/api/v1/media-center?ids="
export const CREATE_FOLDER = "/api/v1/folder/create"
export const DELETE_FOLDER = "/api/v1/folder/"
export const GET_FOLDER = "/api/v1/folder"
export const GET_MEDIA_BY_FOLDER = "/api/v1/media-center/folder"
export const CHECK_MEDIA_URL = "/api/v1/media-center/validate"
export const MEDIA_MOVE_TO = "/api/v1/media-center/move"
export const DELETE_DRAFT_PRODUCT = "/api/v1/product-draft/";
export const GET_PRODUCT_AI_DETAIL = "/api/vi/products/aidata"
export const GET_BRAND = "/api/v1/brand/allbrands";
export const GET_CATEGORY_LIST = "/api/v1/category/list";
export const GET_CAMPAIGN_PRODUCTS = "/api/v1/marketing-campaign/product";
export const GET_ORDERS_CSV = "/api/v1/order/csv";
export const GET_SELLER_BRANDS = "/api/v1/brand/sellersubbrands";
export const GET_S3 = "/api/v1/s3-upload";
export const UPDATE_ORDERS_QUANTITY = "/api/v1/order/quantity";
export const UPDATE_PRODUCT_AVAILABLITY = "/api/v1/order/productAvailablity";
export const UPDATE_ORDER_STATUS_TIME = "/api/v1/order/newOrderStatus";
export const UPDATE_ORDER_EXTEND_TIME = "/api/v1/order/extendedTime";
export const GET_REVIEWS = "/api/v1/reviews";
export const GET_REVIEWS_STATICS = "/api/v1/reviews/statistics";
export const REVIEW_REPLY = "/api/v1/reviews/reply";
export const REVIEW_DISPUTE = "/api/v1/reviews/dispute";
export const GET_REVIEW_ANALYSIS = "/api/v1/reviews/analysis";
export const GET_VOCHERS = "/api/v1/vouchers";
export const VOUCHERTOGGLE = "/api/v1/vouchers/toggle";
export const CREATE_CHAT = "/api/v1/chat/sendMessage";
export const CREATE_CHAT_FOR_ADMIN = "/api/v1/chat/createChatForAdmin";
export const POST_VOUCHER = "/api/v1/vouchers/create";
export const UPDATE_VOUCHER = "/api/v1/vouchers/update";
export const GET_ORDER_STATEMENT_DETAIL = "/api/v1/order-statements/detail";
export const ORDER_STATEMENT_INCOME_LIST ="/api/v1/order-statements/order-statements/income";
export const ORDER_DETAIL_INCOME ="/api/v1/order-statements/order/detail";
export const GET_QSDB = "/api/v1/questdb";


// endpoint for the api ai 
export const GET_CATEGORY_SEARCH_AI = "/bot/search-categories/";
export const GET_VOUCHER_DETAIL = "/api/v1/vouchers/byId"
export const GET_MARKETING_DETAIL = "/api/v1/marketing-campaign/byId"
export const GET_MARKETING_CAMPAIGN_REGISTERED = "/api/v1/marketing-campaign/registered"
